import React from 'react';

import {iconBase} from '../../utils';

import Select from '../form/Select.jsx';
import Input from '../form/Input.jsx';
import {FaTrash} from 'react-icons/fa';

class AllocationsTable extends React.Component {
    static defaultProps = {
        product: null,
        templateSelect: true,
        allocations: [],
        onAllocChange: () => {}
    }

    col_labels = {
        branch: 'Branch',
        collection: 'Collection',
        fund: 'Fund',
        holding_code: 'Holding Code',
        item_type: 'Item Type',
        location: 'Location'
    }
    base_allocation = {
        'branch': null,
        'collection': null,
        'fund': null,
        'holding_code': null,
        'item_type': null,
        'location': null,
        'qty': 0
    }
    inputs = {}

    handleAddRow = (event) => {
        event.preventDefault();
        let {product, cartId, allocations} = this.props;
        let sku = product && product.sku;
        this.props.onAllocChange(cartId, sku, [...allocations, this.base_allocation]);
    }

    handleClearAlloc = (event) => {
        event.preventDefault();
        let {product, cartId} = this.props;
        let sku = product && product.sku;
        this.props.onAllocChange(cartId, sku, []);
    }

    handleGridSelect = (event) => {
        let data = null;
        let {product, cartId, account} = this.props;
        let sku = product && product.sku;
        let value = event.currentTarget.value;

        if (value === '') {
            return false;
        }

        if (value === 'custom') {
            data = [this.base_allocation];
        }

        let user_template = account.grid.templates.find(tmpl=>tmpl._id === value);
        if (user_template) {
            data = user_template.rows;
        }

        if (!data) {
            console.log('no data');
            console.log(data);
            console.log(event.currentTarget.value);
            return false;
        }

        this.props.onAllocChange(cartId, sku, data);
    }

    handleItemChange = (event) => {
        let {product, cartId} = this.props;
        let sku = product && product.sku;
        let data = [];

        for (let row in this.inputs) {
            let row_data = {...this.base_allocation};
            for (let key in this.inputs[row]) {
                let raw_value = this.inputs[row][key]._input.value;
                let value = key === 'qty' ? parseInt(raw_value, 10) : raw_value;
                row_data[key] = raw_value ? value : null;
            }

            data.push(row_data);
        }

        this.props.onAllocChange(cartId, sku, data);
    }

    render () {
        let {account, allocations, product, isReadOnly, templateSelect} = this.props;

        if (!allocations.length && templateSelect) {
            return (
                <div>
                    {isReadOnly &&
                        <div className="a-right">No Grid Selected.</div>
                    }
                    {!isReadOnly &&
                        <section className="envalo_table form-inline l-text-right">
                            <label htmlFor={`template_select_${product.sku}`}>Please choose a grid template to apply:</label>{' '}
                            <select name="template_select" id={`template_select_${product.sku}`} onChange={this.handleGridSelect}>
                                <option value="">-- Select Grid Template--</option>
                                <option value="custom">** Custom Grid **</option>
                                {account.grid.templates.map(tmpl => {
                                    let qty = 0;
                                    tmpl.rows.forEach(row=>qty+=row.qty);
                                    return (<option key={`tmpl_${tmpl._id}`} value={tmpl._id}>{tmpl.name} - ({tmpl.rows.length} rows, {qty} qty)</option>)
                                })}
                            </select>
                        </section>
                    }
                </div>
            )
        }

        let cols = account.grid.columns.filter(col=>col.values.length);

        let allocTotal = 0;

        allocations.forEach(line => {
            allocTotal += parseInt(line.qty || 0, 10)
        });

        let errorMessage = null;

        if (product && product.qty > allocTotal) {
            errorMessage = <span>You have under-allocated by {product.qty - allocTotal}</span>
        } else if (product && allocTotal > product.qty) {
            errorMessage = <span>You have over-allocated by {allocTotal - product.qty}</span>
        }

        this.rows = allocations.map((item, row_index) => {
            if (!this.inputs[row_index]) {
                this.inputs[row_index] = {};
            }
            return (<tr key={row_index}>
                {cols.map((col, index) => {
                    var item_id = `${col.name}:${row_index}`;

                    return (<td key={index}>
                        {isReadOnly ?
                            item[col.name] || '---' :
                            <Select ref={ref=>this.inputs[row_index][col.name] = ref} id={item_id} key={col.name} value={item[col.name]} onChange={this.handleItemChange}>
                                <option value="">----</option>
                                {col.values.map((value) => {
                                    return <option key={value.code} value={value.code}>{value.code}</option>;
                                })}
                            </Select>
                        }
                    </td>)
                })}
                <td className="l-text-center">
                    {isReadOnly && item.qty}
                    {!isReadOnly &&
                        <Input ref={ref=>this.inputs[row_index].qty = ref} id={'qty'} type="number" value={item.qty} onChange={this.handleItemChange} className="qty" />
                    }
                </td>
                {!isReadOnly &&
                    <td className="l-text-center">
                        <a href="#remove"><FaTrash {...iconBase} /></a>
                    </td>
                }
            </tr>)
        });

        return (<div>
                <div className="row-default">
                    <div className="lg-6">
                        <h5 className="table-title">Allocations</h5>
                    </div>

                    {!isReadOnly &&
                        <div className="lg-6 button-set l-text-right">
                            <button className="button-small button" onClick={this.handleAddRow}>
                                Add New Allocation
                            </button>
                            <button className="js-alloc-clear button-small button" onClick={this.handleClearAlloc}>Clear Allocation</button>
                        </div>
                    }

                </div>
                <div className="envalo_table">
                    <table className='table'>
                        <thead>
                            <tr>
                                {cols.map((col) => {
                                    return (<th key={`ils_column_${col.name}`} className='table-header'>{this.col_labels[col.name]}</th>)
                                })}
                                <th className="l-text-center">Qty</th>
                                {!isReadOnly && <th className="l-text-center">Remove</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {this.rows}
                        </tbody>
                    </table>
                    <div className="row-default f-align-center">
                        <div className="lg-9 text-danger">
                            {errorMessage}
                        </div>
                        <div className="lg-3">
                            Total: {allocTotal}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AllocationsTable
